import { createAction } from "@reduxjs/toolkit";
import {MapFilter, MapState} from "@ots-frontend/ots-ui";
import { MapFocusPoint } from "../../model/map";

export const setMapState = createAction<MapState>("map/setMapState");
export const setMapFocusPoint = createAction<MapFocusPoint | undefined>("map/setMapFocusPoint");
export const setMapFilter = createAction<MapFilter>("map/setMapFilter")
export const setMapFilterEntity = createAction<"VEHICLE" | "TRAILER" | "PERSON">("map/setMapFilterEntity")
